export default "__VITE_ASSET__D7U7lCE2__"